import { supabase, SupabaseNotConfiguredError } from "../supabase";
import type { ReviewEvent } from "../db";

/** Immutable event ids make offline retries idempotent, including lost ACKs. */
export async function pushReviewEvents(userId: string, events: ReviewEvent[]): Promise<void> {
  if (events.length === 0) return;
  if (!supabase) throw new SupabaseNotConfiguredError();
  for (let i = 0; i < events.length; i += 500) {
    const { error } = await supabase.from("review_events").upsert(events.slice(i, i + 500).map((e) => ({
      user_id: userId, id: e.id, card_key: e.cardKey, deck_id: e.deckId ?? null,
      reviewed_at: new Date(e.reviewedAt).toISOString(), review_date: e.reviewDate,
      quality: e.quality, is_new: e.isNew,
    })), { onConflict: "user_id,id", ignoreDuplicates: true });
    if (error) throw error;
  }
}

export async function pullReviewEvents(userId: string): Promise<ReviewEvent[]> {
  if (!supabase) throw new SupabaseNotConfiguredError();
  const events: ReviewEvent[] = [];
  let after: string | undefined;
  for (;;) {
    let query = supabase.from("review_events").select("*")
      .eq("user_id", userId).order("id").limit(500);
    if (after !== undefined) query = query.gt("id", after);
    const { data, error } = await query;
    if (error) throw error;
    events.push(...(data ?? []).map((e) => ({ id: e.id, cardKey: e.card_key,
      deckId: e.deck_id ?? undefined, reviewedAt: new Date(e.reviewed_at).getTime(),
      reviewDate: e.review_date, quality: e.quality, isNew: e.is_new })));
    if ((data ?? []).length < 500) return events;
    after = data![data!.length - 1].id;
  }
}
